/* assets/mpb.js */
/* MPB: current page is the bundle parent + swatches render immediately (split too) */
(function () {
  const START_EVENTS = ["DOMContentLoaded","shopify:section:load","shopify:section:select"];
  START_EVENTS.forEach(e => document.addEventListener(e, boot));
  if (document.readyState !== "loading") boot();

  // ---------- helpers ----------
  function moneyFmt(cents) {
    const locale = document.documentElement.lang || "en-US";
    const currency = (window.Shopify?.currency?.active) || "USD";
    const amount = (Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat(locale, { style:"currency", currency }).format(amount); }
    catch { return `$${amount.toFixed(2)}`; }
  }
  function parseJSONSafe(text, fallback=[]) { try { return JSON.parse(text); } catch { return fallback; } }
  function readPayload(root, bid){
    const node = root.querySelector(`#mpb-products-${bid}`);
    let data = [];
    if (node) data = parseJSONSafe(node.textContent || "[]", []);
    if (!Array.isArray(data) || data.length === 0) {
      const inline = root.getAttribute('data-products');
      if (inline) data = parseJSONSafe(inline, []);
    }
    return Array.isArray(data) ? data : [];
  }
  const uuid = () =>
    (window.crypto?.randomUUID?.() ||
      "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        const r = Math.random()*16|0, v = c==="x"?r:(r&0x3|0x8); return v.toString(16);
      })
    );

  // ---------- color map ----------
  window.MPB_COLOR_HEX = Object.assign({
    "Lilac":"#C8B7FF","Poppy":"#FF6B6B","Sky Blue":"#89C2FF","Oat":"#E9E1D1","Green":"#47B276",
    "Blueberry":"#6C7BFF","Black":"#000000","White":"#FFFFFF","Gray":"#999999","Grey":"#999999",
    "Red":"#E11900","Orange":"#FA6400","Yellow":"#FFC400","Pink":"#FF9AC2","Purple":"#7A5AF8",
    "Navy":"#1F2D5A","Beige":"#E7DCC8","Brown":"#8E6E53"
  }, window.MPB_COLOR_HEX || {});

  function hexFor(name) {
    if (!name) return "#EEE";
    const key = String(name).trim();
    const MAP = window.MPB_COLOR_HEX || {};
    if (MAP[key]) return MAP[key];
    const found = Object.keys(MAP).find(k => k.toLowerCase() === key.toLowerCase());
    if (found) return MAP[found];
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(key)) return key;
    return "#EEE";
  }
  function swatchBG(value){
    const raw = String(value || "").trim();
    const parts = raw.split(/\s*(?:\/|&|\+|,)\s*/).filter(Boolean);
    if (parts.length >= 2){
      const a = hexFor(parts[0]);
      const b = hexFor(parts[1]);
      return `linear-gradient(90deg, ${a} 0 50%, ${b} 50% 100%)`;
    }
    return hexFor(raw);
  }

  // ---------- MPB staging (per block) ----------
  window.MPB = window.MPB || (function(){
    const map = new Map(); // bid -> items[]
    return {
      setSelections(bid, items){ map.set(String(bid), items || []); },
      getStagedLineItems(peek=false){
        const flat = Array.from(map.values()).flat();
        if (!peek) map.clear();
        return flat;
      }
    };
  })();

  function boot(){
    document.querySelectorAll('.mpb[data-bid]').forEach(init);
    // NOTE: no wireATC(); the theme's buy-buttons handles add-to-cart
  }

  function init(root){
    if (root.__mpbMounted) return;
    root.__mpbMounted = true;

    const bid = root.dataset.bid;
    const discountPercent = Math.max(0, parseFloat(root.dataset.discountPercent || "0")) || 0;

    const listEl    = root.querySelector(`#mpb-list-${bid}`);
    const totalEl   = root.querySelector(`#mpb-total-${bid}`);
    const compareEl = root.querySelector(`#mpb-compare-${bid}`);

    const products = readPayload(root, bid);
    if (!products.length) {
      listEl.innerHTML = `<div style="opacity:.7">No bundle products configured.</div>`;
      window.MPB.setSelections(bid, []);
      return;
    }

    const selected = new Map(); // slot -> variant

    renderAll();

    function renderAll(){
      listEl.innerHTML = "";

      products.forEach(prod => {
        const { slot, title, featured_image, variants = [], options = [] } = prod;

        const colorIdx = options.findIndex(o => /color/i.test(o.name || o));
        const sizeIdx  = options.findIndex((o, i) => i !== colorIdx && /size|length|dimension/i.test((o.name||o)));
        const otherIdx = sizeIdx === -1 ? options.findIndex((o,i)=> i!==colorIdx) : sizeIdx;

        // default variant (prefer available)
        const def = variants.find(v => v.available) || variants[0];
        selected.set(slot, def);

        const card = document.createElement('div');
        card.className = 'mpb-card';

        const imgWrap = document.createElement('div');
        imgWrap.className = 'mpb-card__img';
        const imgEl = document.createElement('img');
        imgEl.src = (def?.featured_image) || featured_image || "";
        imgWrap.innerHTML = "";
        imgWrap.appendChild(imgEl);

        const body = document.createElement('div');

        const titleEl = document.createElement('div');
        titleEl.className = 'mpb-card__title';
        titleEl.textContent = title || "Product";

        const priceLine = document.createElement('div');
        priceLine.className = 'mpb-price';
        const was = document.createElement('s'); was.className = 'was';
        const now = document.createElement('span');

        function setPriceFor(variant){
          const p  = Number(variant?.price || 0);
          const cp = Number(variant?.compare_at_price || 0);
          now.textContent = moneyFmt(p);
          if (cp > p) { was.hidden = false; was.textContent = moneyFmt(cp); }
          else { was.hidden = true; was.textContent = ""; }
        }
        setPriceFor(def);
        priceLine.append(was, now);

        const optWrap = document.createElement('div');
        optWrap.className = 'mpb-opt';

        function updateCardVisuals(variant){
          setPriceFor(variant);
          const src = variant.featured_image || featured_image || "";
          if (src) imgEl.src = src;
          if (sizeRow) refreshSizeRow(sizeRow, variants, colorIdx, otherIdx, variant);
          if (card.__refreshSwatches) card.__refreshSwatches(variant);
          recalcAndStage();
        }

        // COLOR SWATCHES
        if (colorIdx > -1) {
          const row = document.createElement('div');
          row.className = 'mpb-opt-row';

          const colorValues = [];
          variants.forEach(v => {
            const val = v.options[colorIdx];
            if (val && !colorValues.includes(val)) colorValues.push(val);
          });

          function makeSwatch(val, currentOther, isActive){
            const sw = document.createElement('button');
            sw.type = "button";
            sw.className = 'mpb-swatch';
            sw.setAttribute('aria-label', val);

            // inner fill to defeat theme background overrides
            const fill = document.createElement('span');
            fill.className = 'mpb-swatch__fill';
            const bg = swatchBG(val);
            fill.style.background = bg;
            sw.appendChild(fill);

            const availableWithOther = variants.some(v =>
              v.options[colorIdx] === val &&
              (otherIdx === -1 || v.options[otherIdx] === currentOther) &&
              v.available
            );
            if (!availableWithOther) {
              sw.classList.add('is-oos');
              sw.setAttribute('aria-disabled','true');
              sw.tabIndex = -1;
            }
            if (isActive) sw.classList.add('is-active');

            sw.addEventListener('click', () => {
              if (sw.classList.contains('is-oos')) return;
              const current = selected.get(slot);
              const target = chooseVariant(variants, {
                [colorIdx]: val,
                [otherIdx]: current ? current.options[otherIdx] : undefined
              });
              if (!target) return;
              selected.set(slot, target);
              updateCardVisuals(target);
            });

            return sw;
          }

          function refreshSwatchRow(currentVariant){
            row.innerHTML = "";
            const currentOther = currentVariant ? currentVariant.options[otherIdx] : undefined;
            colorValues.forEach(val => {
              const isActive = currentVariant && currentVariant.options[colorIdx] === val;
              row.appendChild(makeSwatch(val, currentOther, isActive));
            });
          }

          refreshSwatchRow(def);
          optWrap.appendChild(row);
          card.__refreshSwatches = refreshSwatchRow;
        }

        // SIZE / OTHER CHIPS
        let sizeRow = null;
        if (otherIdx > -1) {
          sizeRow = document.createElement('div');
          sizeRow.className = 'mpb-opt-row';

          function makeSizeChip(val, available, active) {
            const chip = document.createElement('button');
            chip.type = "button";
            chip.className = 'mpb-chip';
            chip.textContent = val;
            if (!available) { chip.classList.add('is-oos'); chip.setAttribute('aria-disabled','true'); chip.tabIndex = -1; }
            if (active) chip.classList.add('is-active');

            chip.addEventListener('click', () => {
              if (chip.classList.contains('is-oos')) return;
              const current = selected.get(slot);
              const desired = chooseVariant(variants, {
                [otherIdx]: val,
                [colorIdx]: current ? current.options[colorIdx] : undefined
              });
              if (!desired) return;
              selected.set(slot, desired);
              updateCardVisuals(desired);
            });

            return chip;
          }

          function refreshSizeRow(row, variants, colorIdx, otherIdx, currentVariant){
            row.innerHTML = "";
            const values = [];
            variants.forEach(v => {
              const val = v.options[otherIdx];
              if (val && !values.includes(val)) values.push(val);
            });
            values.forEach(val => {
              const availableWithColor = variants.some(v =>
                v.options[otherIdx] === val &&
                (colorIdx === -1 || v.options[colorIdx] === currentVariant.options[colorIdx]) &&
                v.available
              );
              const isActive = currentVariant && currentVariant.options[otherIdx] === val;
              row.appendChild(makeSizeChip(val, availableWithColor, isActive));
            });
          }

          refreshSizeRow(sizeRow, variants, colorIdx, otherIdx, def);
          optWrap.appendChild(sizeRow);
        }

        body.append(titleEl, priceLine, optWrap);
        card.append(imgWrap, body);
        listEl.appendChild(card);
      });

      recalcAndStage();
    }

    function chooseVariant(variants, desiredByIndex){
      let match = variants.find(v =>
        Object.entries(desiredByIndex).every(([idx, val]) =>
          val === undefined || v.options[idx] === val
        ) && v.available
      );
      if (match) return match;
      match = variants.find(v =>
        Object.entries(desiredByIndex).every(([idx, val]) =>
          val === undefined || v.options[idx] === val
        )
      );
      return match || variants[0];
    }

    function recalcAndStage(){
      let sumPrice = 0;
      let sumCompare = 0;
      const items = [];

      selected.forEach(v=>{
        if (!v) return;
        sumPrice   += Number(v.price) || 0;
        sumCompare += Number(v.compare_at_price || v.price) || 0;
        items.push({ id: String(v.id), quantity: 1 });
      });

      const discounted = Math.round(sumPrice * (1 - discountPercent/100));

      if (sumCompare > 0 && sumCompare !== discounted) {
        compareEl.hidden = false;
        compareEl.setAttribute('aria-hidden', 'false');
        compareEl.textContent = moneyFmt(sumCompare);
      } else {
        compareEl.hidden = true;
        compareEl.setAttribute('aria-hidden', 'true');
        compareEl.textContent = '';
      }
      totalEl.textContent = moneyFmt(discounted);

      window.MPB.setSelections(bid, items);
    }
  }

})();
